module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/sorting/sorting.component.css
// module id = ./src/app/examples/sorting/sorting.component.css
// module chunks = main